import { RemapObjectKeysAdapter } from '@/Core.Patterns/Adapter';
import API from '@/Core.Service.Domain/Strategies/Strategies/API/index.ts';

const getSitesWithStrategies = async (context) => {
  const sitesWithStrategies = await API.getSitesWithStrategies();
  context.commit('SITES_WITH_STRATEGIES', sitesWithStrategies);
};

const getStrategiesBySiteId = async (context, site) => {
  const { selectedSite } = site;

  const remappedSelectedSite = RemapObjectKeysAdapter(
    selectedSite,
    ['id'],
    ['siteId']
  );

  context.commit('SELECTED_SITE_STRATEGIES_IS_LOADING', true);

  const selectedSiteStrategies = await API.getStrategiesBySiteId(
    remappedSelectedSite
  );

  context.commit('SELECTED_SITE_STRATEGIES', selectedSiteStrategies);
  context.commit('SELECTED_SITE_STRATEGIES_IS_LOADING', false);
};

const setStrategyCurrentRoute = async (context, strategyCurrentRoute) => {
  context.commit('STRATEGY_CURRENT_ROUTE', strategyCurrentRoute);
};

const getStrategyTodaysHistoryByStrategyId = async (context, strategy) => {
  try {
    context.commit('IS_HISTORY_LOADING', true);
    const { strategyId } = strategy;
    const strategyTodaysHistory =
      await API.getStrategyTodaysHistoryByStrategyId(strategyId);

    context.commit('STRATEGY_TODAYS_HISTORY', strategyTodaysHistory);

    return strategyTodaysHistory;
  } catch (err) {
    return Promise.reject(err);
  } finally {
    context.commit('IS_HISTORY_LOADING', false);
  }
};

const getStrategyHistoryByDate = async (context, strategy) => {
  try {
    context.commit('IS_HISTORY_LOADING', true);
    const { strategyId, date } = strategy;
    const strategyHistory = await API.getStrategyHistoryByDate(
      strategyId,
      date
    );

    context.commit('STRATEGY_TODAYS_HISTORY', strategyHistory);

    return strategyHistory;
  } catch (err) {
    return Promise.reject(err);
  } finally {
    context.commit('IS_HISTORY_LOADING', false);
  }
};

export default {
  getSitesWithStrategies,
  getStrategiesBySiteId,
  setStrategyCurrentRoute,
  getStrategyTodaysHistoryByStrategyId,
  getStrategyHistoryByDate,
};
